import { all } from 'redux-saga/effects';
import PreferenceSagas from 'common/notifications/sagas/PreferenceSagas';
import UserNotificationsSagas from 'common/notifications/sagas/UserNotificationsSagas';

export default function* sagas() {
  yield all([
    ...UserNotificationsSagas,
    ...PreferenceSagas
  ]);
}
